import {
  SET_ORDERS,
  API_ORDERS_FETCH_ALL_START,
  API_ORDERS_FETCH_ALL_SUCCESS,
  API_ORDERS_FETCH_ALL_FAILURE,
  API_ORDERS_CREATE_START,
  API_ORDERS_CREATE_SUCCESS,
  API_ORDERS_CREATE_FAILURE
} from '../types/orders'

export const setOrders = orders => ({ type: SET_ORDERS, orders })

export const apiOrdersFetchAllStart = () => ({ type: API_ORDERS_FETCH_ALL_START })
export const apiOrdersFetchAllSuccess = () => ({ type: API_ORDERS_FETCH_ALL_SUCCESS })
export const apiOrdersFetchAllFailure = error => ({ type: API_ORDERS_FETCH_ALL_FAILURE, error })

export const apiOrdersCreateStart = () => ({ type: API_ORDERS_CREATE_START })
export const apiOrdersCreateSuccess = () => ({ type: API_ORDERS_CREATE_SUCCESS })
export const apiOrdersCreateFailure = error => ({ type: API_ORDERS_CREATE_FAILURE, error })
